import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const renderDescription = (text) => {
    return (
      <Tooltip placement="top" title={text}>
        <ExclamationCircleOutlined style={{ color: "InfoText" }} />
      </Tooltip>
    );
  };
  
export const descriptions = {
    giftSold: "Sử dụng Credit note khi muốn tạo refund cho khách hàng và các job cần sửa lỗi.",
    voucherSold: "Áp dụng cho Gift card và E-voucher.",
    evidence: "Chụp hình ảnh Bank Transfer",
  };
  